import React, {useEffect,useState} from "react";
import {Link} from "react-router-dom";
import {post} from './../../networking/Api';
import Constent from './../../networking/Constent';
import {Alert} from "./../../alertServices";
import { withTranslation } from 'react-i18next';
import moment from 'moment';

const dummyImage =  process.env.PUBLIC_URL + '/assets/img/default-user.jpg';
let TASKLIST = [];
function ProjectActivity(props){
	const [taskList, setTaskList] = useState(TASKLIST);
	const [taskCount, setTaskCount] = useState(-1);
	useEffect(() => {
        getList();
    },[]);

	function getList(){
        var formData=new FormData();
        formData.append("project_id",props.project_id);
        formData.append("department_id",localStorage.getItem('department_id'));
        
        post(Constent.GETPROJECTACTIVITY,formData).then(response =>{
            if(response.status===1){
                setTaskList(response.data.comments);
                setTaskCount(response.data.comments.length);
            }else{
                Alert.error({title: response.message});
            }
        })
    }

   return(
		<div style={{marginTop:20}}>
            <div  >
            {taskCount < 0 ? <p className="text-center">Loading....</p> : '' }
            {taskCount === 0 ? <p className="text-center">No record available</p> : '' }
            {taskList && taskList.map((item, _key) => (

                <div className='single-goal project-task' style={{marginBottom: '5px'}}>
                {
                    item.comments.map(
                    (comment, key) => (
                        <div className="row" key={key}>
                            <div className="col-1">
                                <img src={item.user_image} className="project-assign-img" alt={comment.commented_by} />
                            </div>
                            <div className="col-10 border-btm">
                                <div className="title">{comment.comment} <small className="float-right color-gray">{moment(item.created_at, "YYYY-MM-DD hh:mm:ss").format("MMM DD, YYYY")}</small></div>
                                <p className="color-gray">{(item.material_name) ? item.material_name : '' }  {(item.cost) ? ' | ' + item.cost + 'DKK' : ''}   <span className="float-right">{comment.commented_by}</span> </p>
                                {/* {(comment.file) ? 
                                <p>
                                    <img src={comment.file_url} alt="file" style={{width:50,height:50}}/>
                                    &nbsp; <a href={comment.file_ahref}>{comment.file}</a>
                                </p>
                                : ''}   */}
                            </div>
                        </div>
                    )
                    )
                }
            
                <div className="row" style={{paddingLeft: '110px'}}>
                    {item.files.map(
                        (file, key) => (
                        
                            <div className="col-1">
                                <a target="_blank" href={file.file_url} > { file.file_name }</a>
                            </div> 
                            
                        )
                    )}
                </div>
            
            
                </div>
            ))}



           </div>
        </div>
	);
}

export default ProjectActivity;